export var FontFamily;
(function (FontFamily) {
    FontFamily["Lustria"] = "lustria";
    FontFamily["Mundial"] = "mundial";
})(FontFamily || (FontFamily = {}));
